
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/figma-to-pdf",
      function () {
        return require("private-next-pages/converter/figma-to-pdf.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/figma-to-pdf"])
      });
    }
  